import React from 'react';

const PasswordResetErrorForm = () => {
    return (
        <React.Fragment>
            <h1>Error Resetting Password</h1>
            <div>
                <p>There was an error resetting your password.</p>
            </div>
        </React.Fragment>
    )
}

export default PasswordResetErrorForm